// extracted by mini-css-extract-plugin
export default {"temp":"EkgRecording_temp__0yImw","ekgRecording":"EkgRecording_ekgRecording__QDtlB","topSVG":"EkgRecording_topSVG__9VSyf","canvas":"EkgRecording_canvas__YvLR1"};